export const PROJECT_SECTION_TAB_VALUES = {
  classification: ["classification"],
  documents: ["preparation", "operator-review", "risk", "gspr", "notified-body", "ce-marking", "techfile", "clinical", "aiact", "documents"],
};

export const ROLE_WORKSPACE = {
  manufacturer: {
    labelKey: "role.manufacturer",
    summaryKey: "role.summary.manufacturer",
    regulatoryTabs: [
      "preparation", "classification", "risk", "gspr", "notified-body", "ce-marking",
      "techfile", "clinical", "aiact", "documents",
    ],
    postmarketTabs: [
      "pms", "pmcf", "capa", "ncr", "complaints", "recall", "fsca", "trace",
      "audit",
    ],
    defaultRegulatoryTab: "preparation",
    defaultPostmarketTab: "pms",
  },
  importer: {
    labelKey: "role.importer",
    summaryKey: "role.summary.importer",
    regulatoryTabs: ["preparation", "operator-review", "notified-body", "ce-marking", "techfile"],
    postmarketTabs: ["trace", "complaints", "recall", "fsca"],
    defaultRegulatoryTab: "preparation",
    defaultPostmarketTab: "trace",
  },
  distributor: {
    labelKey: "role.distributor",
    summaryKey: "role.summary.distributor",
    regulatoryTabs: ["preparation", "operator-review", "ce-marking"],
    postmarketTabs: ["trace", "complaints", "recall", "fsca"],
    defaultRegulatoryTab: "preparation",
    defaultPostmarketTab: "trace",
  },
};

export function getVisibleRegulatoryTabs(role, aiActApplicable = false) {
  const workspace = ROLE_WORKSPACE[role];
  if (!workspace) return [];
  return workspace.regulatoryTabs.filter(
    (tab) => tab !== "aiact" || (role === "manufacturer" && aiActApplicable),
  );
}

export function getVisibleProjectSectionTabs(role, aiActApplicable = false) {
  const workspace = ROLE_WORKSPACE[role];
  if (!workspace) return { classification: [], documents: [], traceability: [] };
  const visibleRegulatoryTabs = getVisibleRegulatoryTabs(role, aiActApplicable);
  return {
    classification: visibleRegulatoryTabs.filter((tab) => PROJECT_SECTION_TAB_VALUES.classification.includes(tab)),
    documents: visibleRegulatoryTabs.filter((tab) => PROJECT_SECTION_TAB_VALUES.documents.includes(tab)),
    traceability: workspace.postmarketTabs,
  };
}

export function getVisibleProjectModules(role, aiActApplicable = false) {
  if (!ROLE_WORKSPACE[role]) return [];
  const sections = getVisibleProjectSectionTabs(role, aiActApplicable);
  return [...new Set([
    ...sections.classification,
    "preparation",
    ...sections.documents.filter((tab) => !["preparation", "documents", "submission"].includes(tab)),
    "documents",
    ...sections.traceability,
  ])];
}

export function canManageGeneratedDocuments(role) {
  return role === "manufacturer";
}

export function normalizeEconomicRole(value = "") {
  const normalized = String(value).trim().toLowerCase();
  if (normalized.includes("manufacturer") || normalized.includes("fabricante")) return "manufacturer";
  if (normalized.includes("importer") || normalized.includes("importador")) return "importer";
  if (normalized.includes("distributor") || normalized.includes("distribuidor")) return "distributor";
  return "";
}

export function getApplicableProjectRole(projectRole) {
  return normalizeEconomicRole(projectRole);
}

